import { ViewController, ObjectSelectEvent } from "@gaming/srvg-classes-core";
import { ChunkPickerView } from "../../View/ChunkPickerView";
import { Chunk } from "../../Data/Chunk";
import { ChunkPickEvent } from "../../Event/ChunkPickEvent";
import { PhaseChangeEvent } from "../../Event/PhaseChangeEvent";
import { ChunkChangeEvent } from "../../Event/ChunkChangeEvent";
import { ChunkRangeChangeEvent } from "../../Event/ChunkRangeChangeEvent";

export class ChunkPickerViewController extends ViewController {
    chunkPickerView: ChunkPickerView;

    constructor( options ) {
        options = options || {};
        options.view = options.chunkPickerView || null;
        options.name = options.name || 'chunkPickerViewController';
        super( options );
        this.chunkPickerView = options.chunkPickerView || null;

        this.view.setDelegate(this);

        this.generatedEvents.push( ChunkPickEvent );
        this.generatedEvents.push( PhaseChangeEvent  );
    }

    // ************************** Event handlers **************************

    /**
     *
     */
    handleChunkChangeEvent( event:ChunkChangeEvent, provider ) {
        this.chunkPickerView.setChunk( event.chunk );
    }

    /**
     * Called when the chunk picker sends a chunkPick event. Forwards the event.
     */
    handleObjectSelectEvent(event: ObjectSelectEvent, provider) {
        //console.log( 'ChunkPickerViewController.handleChunkPickEvent' );
        var chunk = <Chunk>event.object;
        this.triggerEvent( new ChunkPickEvent( chunk ) )
    }

    /**
     * Event handler for timeout events (sent by inactivity controller)
     */
    handleTimeoutEvent(event, provider) {
        this.chunkPickerView.disable();
    }

    handleChunkRangeChangeEvent( event: ChunkRangeChangeEvent, provider ) {
        this.chunkPickerView.refresh();
    }
}
